import { EventActionType } from './event-action-type';

interface OccurrenceItem {
  startsAt: Date;
  duration?: number;
}

export interface AddManyEventOccurrenceAction {
  occurrences: OccurrenceItem[];
  type: EventActionType.AddManyOccurrences;
  eventKey: string;
}

export const addManyEventOccurrences = (
  eventKey: string,
  occurrences: OccurrenceItem[],
): AddManyEventOccurrenceAction => ({
  eventKey,
  occurrences,
  type: EventActionType.AddManyOccurrences,
});
